import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

interface WarningAlertIconProps {
  width?: number;
  height?: number;
}

const WarningAlertIcon = ({ width = 16, height = 16, ...rest }: WarningAlertIconProps) => {
  const { token } = useToken();

  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M0.5 2C0.5 0.895431 1.39543 0 2.5 0H14.5C15.6046 0 16.5 0.895431 16.5 2V14C16.5 15.1046 15.6046 16 14.5 16H2.5C1.39543 16 0.5 15.1046 0.5 14V2Z"
        fill={token.colorWarningBg}
      />
      <path
        d="M9.17527 3.88531L13.275 11.0042C13.5623 11.5058 13.1911 12.125 12.5995 12.125H4.40012C3.80855 12.125 3.4373 11.5058 3.72465 11.0042L7.82433 3.88531C8.11965 3.37156 8.87996 3.37156 9.17527 3.88531Z"
        stroke={token.colorWarning}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.5 8.75V6.875" stroke={token.colorWarning} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8.5 10.8125C8.70711 10.8125 8.875 10.6446 8.875 10.4375C8.875 10.2304 8.70711 10.0625 8.5 10.0625C8.29289 10.0625 8.125 10.2304 8.125 10.4375C8.125 10.6446 8.29289 10.8125 8.5 10.8125Z"
        fill={token.colorWarning}
      />
    </svg>
  );
};

export default WarningAlertIcon;
